module.exports = __webpack_public_path__ + "img/28.b8386fb7.png";